import { render, staticRenderFns } from "./EmployeeLeave.vue?vue&type=template&id=2995c6a4"
import script from "./EmployeeLeave.vue?vue&type=script&lang=js"
export * from "./EmployeeLeave.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeave.vue?vue&type=style&index=0&id=2995c6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports